export default __webpack_public_path__ + "static/media/couverture-mariage-à-tout-prix-magazine-juillet-2018-facebook.c352e07e.jpg";